import sessionsReducer from './';

export default sessionsReducer;
